module.exports = __webpack_public_path__ + "img/sankaku_86_blue.be97e6aa.png";